import { AppPlatformEnums, SECOND_MERCHANT_TYPE } from "@/enums/app";
import { queryRequest } from "@/utils/request";
import { getSystemValue } from "@/graphql/app.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import { SystemVars } from "@/enums/system";
import { getPlatform } from "@/utils/project";
export default {
  namespaced: true,
  state() {
    return {
      platform: "", // JA, JT,  / 佳安，佳通
      storeTag: [], // 门店tag数组，是否是二批商
      storeInfo: {}, // 门店信息
      cacheRoutes: [],
      title: "",
      promotionFlag: false, // 秒杀开关
      mallServicePhone: "", // 商城客服电话
      routeBack: false, // 页面返回状态
      pageTransitionName: "slide-fade"
    };
  },
  mutations: {
    saveStoreInfoMutation(state, data: any = {}) {
      state.storeInfo = data || {};
    },
    saveStoreTagMutation(state, data: any[]) {
      state.storeTag = data || [];
    },
    savePlatformMutation(state, data: string) {
      state.platform = data || "";
    },
    setCacheRoutesMutation(state, data) {
      state.cacheRoutes = data || [];
    },
    saveTitleMutation(state, data: string = "") {
      state.title = data;
      document.title = data;
      window.nativeApp?.setTitle(data);
    },
    savePromotionFlagMutation(state, data: any = "") {
      state.promotionFlag = data;
    },
    saveMallServicePhoneMutation(state, data: string = "") {
      state.mallServicePhone = data;
    },
    setRouteBackMutation(state, data = false) {
      state.routeBack = !!data;
    },
    setPageTransitionNameMutation(state, data = "") {
      state.pageTransitionName = data;
    }
  },

  getters: {
    // 是否是二批商
    isSecondMerchant(state) {
      return state.storeTag.includes(SECOND_MERCHANT_TYPE);
    }
  },
  actions: {
    // 获取平台
    async getPlatformAction({ commit }) {
      const {
        platform = AppPlatformEnums.TBR,
        storeTag,
        storeInfo
      } = await getPlatform();

      console.log(69, platform, storeTag, storeInfo);
      commit("savePlatformMutation", platform);
      commit("saveStoreTagMutation", storeTag);
      commit("saveStoreInfoMutation", storeInfo);
    },
    // 获取系统变量
    async getSystemDataAction(context, params) {
      let data = await queryRequest({
        query: getSystemValue,
        variables: params
      });
      return data?.value;
    },
    // 获取系统变量
    async queryDataDictionaryListLang(context, params) {
      let data = await queryRequest({
        query: queryDataDictionaryListLang,
        variables: params
      });
      return data;
    },
    // wt 首页控制秒杀是否开启
    async getPromotionFlag({ commit, dispatch }) {
      commit(
        "savePromotionFlagMutation",
        await dispatch("getSystemDataAction", {
          input: { valueCode: SystemVars.WT_PROMOTION_FLAG }
        })
      );
    },
    // 查询WT商城客服电话
    async getMallServicePhone({ commit, dispatch }) {
      // commit(
      //   "saveMallServicePhoneMutation",
      //   await dispatch("getSystemDataAction", {
      //     input: { valueCode: SystemVars.WT_MALL_SERVICE_PHONE }
      //   })
      // );
    }
  }
};
